import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ScreenIdleStatusCheckService {

  private timeout: any;
  private readonly IDLE_TIME = 5 * 60 * 1000; // 5 minutes

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) {


  }

  startWatching(): void {

    this.resetTimer();
    window.addEventListener('mousemove', () => this.resetTimer());
    window.addEventListener('keydown', () => this.resetTimer());
    window.addEventListener('click', () => this.resetTimer());
    window.addEventListener('scroll', () => this.resetTimer());
  }

  private resetTimer(): void {

    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {

      this.ngZone.run(() => {

        // save current route
        // localStorage.setItem(
        //   'lastActiveRoute',
        //   this.router.url
        // );

        // // redirect to lock page
        // this.router.navigate(['/lock-screen']);

        const currentUrl = this.router.url;


        // routes excluded from locking
        const excludedRoutes = [
          '/Agent-Kyc-Onboarding/video-pd',
          '/Agent-Kyc-Onboarding/videoverification',
          '/Agent-Get-Started/Account-Opening/Saving-Account/Saving-VKYC',
          '/Agent-Get-Started/Account-Opening/Client-Creation/Client-VKYC'
        ];

        // skip excluded pages
        const isExcluded = excludedRoutes.some(route =>
          currentUrl.startsWith(route)
        );

        if (isExcluded) {
          return;
        }


        // routes where lock screen should work
        const protectedUrls = [
          '/Agent-Get-Started',
          '/Agent-Kyc-Onboarding'
        ];

        // check current route
        const shouldLock = protectedUrls.some(url =>
          currentUrl.includes(url)
        );


        if (!shouldLock) {
          return;
        }


        // if (shouldLock) {

        // }

        sessionStorage.setItem('lock_redirect', currentUrl);
        sessionStorage.setItem('isLocked', 'true');
        this.router.navigate(['/lock-screen'], { replaceUrl: true });





      });

    }, this.IDLE_TIME);
  }

  stopWatching(): void {
    clearTimeout(this.timeout);
  }
}
